import { Entry } from '../Entry'

export function Entry20240731() {
  return (
    <Entry title="31/07/2024 - v3.7.9">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/15977/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
